import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=254dfd6e&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254dfd6e')) {
      api.createRecord('254dfd6e', component.options)
    } else {
      api.reload('254dfd6e', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=254dfd6e&", function () {
      api.rerender('254dfd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/avatar.vue"
export default component.exports